<template>
  <section class="section">
    <div class="is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title">Público</h1>
          </div>
          <!-- <h3 style="color: #888888" class="subtitle">{{ getClientName() }}</h3> -->
        </div>
        <div class="level-right">
          <div class="level-item">
            <b-field label="Selecione o Período" label-position="on-border">
              <b-datepicker
                v-model="dates"
                range
                :date-formatter="dateConverter"
                @input="selectDate()"
                icon="calendar-day"
                style="width: 240px"
              >
                ></b-datepicker
              >
            </b-field>
          </div>
        </div>
      </div>

      <div class="subpage">
        <div class="column is-full is-16-mobile">
          <div class="columns">
            <div class="column is-three-fifths is-16-mobile" v-if="hasGender">
              <apex-chart-vertical-bar-age
                :data="dataByAgeNoGender"
              ></apex-chart-vertical-bar-age>
            </div>
            <div class="column is-three-fifths is-16-mobile" v-else>
              <div class="box" id="cardContainer">
                <p class="titleGraph">Faixa Etária</p>
                <h2>
                  <strong
                    >O {{ getClientName() }} não coleta dados para esse
                    gráfico</strong
                  >
                </h2>
              </div>
            </div>

            <div class="column is-two-fifths is-16-mobile" v-if="hasBirth_date">
              <apex-chart-pie-gender
                :data="dataByGender"
              ></apex-chart-pie-gender>
            </div>
            <div class="column is-two-fifths is-16-mobile" v-else>
              <div class="box" id="cardContainer">
                <p class="titleGraph">Gênero</p>
                <h2>
                  <strong
                    >O {{ getClientName() }} não coleta dados para esse
                    gráfico</strong
                  >
                </h2>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-16-mobile">
              <div class="box" id="cardContainer">
                <b class="titleGraph">Faixa Etária e Gênero </b>

                <apex-chart-vertical-bar
                :data="dataByAge"
              ></apex-chart-vertical-bar>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="containerButton">
          <b-button
            id="buttonList"
            icon-right="user"
            type="is-info"
            @click="openModal()"
            >Listar</b-button
          >
        </div> -->
      </div>
    </div>
    <b-modal :active.sync="dialogList" :can-cancel="true">
      <div class="card">
        <div class="card-header">
          <div class="level-right">
            <div class="level-item">
              <b-button
                icon-right="cloud-download-alt"
                type="is-info"
                @click="importUsers(dateSD, dateED)"
                :loading="downloadingUsers"
                >Download Pessoas</b-button
              >
            </div>
            <div class="level-item">
              <b-button
                icon-right="cloud-download-alt"
                type="is-info"
                @click="importConnections(dateSD, dateED)"
                >Download Conexões</b-button
              >
            </div>
          </div>
        </div>

        <div class="card has-table">
          <div class="card-header">
            <div class="is-title-bar" style="margin-top: 20px">
              <div class="level">
                <div class="level-left">
                  <div class="level-item">
                    <b-field
                      label="Selecione o Período"
                      label-position="on-border"
                    >
                      <b-datepicker
                        v-model="dates"
                        range
                        :date-formatter="dateConverter"
                        @input="selectDate()"
                        icon="calendar-day"
                        style="width: 240px"
                      >
                        ></b-datepicker
                      >
                    </b-field>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <b-table
            v-if="fields.length > 0"
            :data="getPersonsList"
            :paginated="true"
            :pagination-simple="true"
            :per-page="perPage"
            striped
            :loading="isLoading"
          >
            <template slot-scope="props">
              <b-table-column
                v-for="(field, index) in getHeaders"
                :key="index"
                :field="field.value"
                :label="field.text"
                class="has-text-left"
                sortable
              >
                {{
                  field.type.toLowerCase() == "date"
                    ? formatDate(props.row[field.value])
                    : props.row[field.value].length == "0" ||
                      props.row[field.value] == " "
                    ? "Não Informado"
                    : props.row[field.value].length == "1"
                    ? props.row[field.value].toUpperCase()
                    : props.row[field.value]
                }}
              </b-table-column>
            </template>
            <template slot="empty">
              <section class="section">
                <div class="has-text-grey has-text-centered">
                  <span>Sem pessoas para exibir</span>
                </div>
              </section>
            </template>
            <template slot="footer">
              <div class="level" style="padding-bottom: 0">
                <div class="level-left"></div>
                <div class="left-center"></div>
                <div class="level-right">
                  <b-select v-model="perPage" size="is-small">
                    <option value="10">10 por página</option>
                    <option value="25">25 por página</option>
                    <option value="50">50 por página</option>
                    <option value="100">100 por página</option>
                  </b-select>
                </div>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <b-button id="buttonCancelar" type="is-light" @click="closeModal()"
        >Cancelar</b-button
      >
    </b-modal>
  </section>
</template>

<script>
import Webservices from "@/Webservices";
import { mapActions, mapGetters } from "vuex";
import store from "@/store";
import ApexChartVerticalBar from "@/components/charts/ApexChartVerticalBar";
import ApexChartVerticalBarAge from "@/components/charts/ApexChartVerticalBarAge";
import ApexChartPieGender from "@/components/charts/ApexChartPieGender";

import {
  dateParser,
  loadDefaultData,
  getPeople,
  getClientFields,
  downloadConnections,
  downloadUsers
} from "../functions/pessoas";

var FileSaver = require("file-saver");
const Json2csvParser = require("json2csv").Parser;
var moment = require("moment");
const ws = new Webservices();

export default {
  components: {
    ApexChartVerticalBar,
    ApexChartVerticalBarAge,
    ApexChartPieGender
  },
  data: () => loadDefaultData(),

  watch: {
    getControllerId(newValue) {
      this.dates = [
        moment()
          .subtract(6, "d")
          .toDate(),
        moment().toDate()
      ];
      this.hasGender = false;
      this.hasBirth_date = false;
      this.dateSD = moment()
        .subtract(6, "d")
        .format("YYYY-MM-DD");
      this.dateED = moment()
        .format("YYYY-MM-DD");

      this.onlineData = [];
      this.data_v2 = [];

      this.loadIterations = 0;
      this.loadGeneralData();

      console.log(this.getID);
      ws.getClientFields("614cb27a1e85c911f39cd112")
      
        .then(response => {
          
          this.fields = response.data.fields.filter(
            el => el.type != "label" && el.is_active
          );

          //this.fields.push({ type: "string", name: "mac", label: "MAC" });
          this.fields = this.fields.map(el => el.name);

          this.fields.forEach(el => {
            if (el === "gender") {
              this.hasGender = true;
            }
            if (el === "birth_date") {
              this.hasBirth_date = true;
            }
          });
        })
        .catch(err => {});
    }
  },

  async mounted() {
    if (await ws.checkAccessToken(this.getToken)) {
      this.logout();
      this.$router.push("/login");
    }
    this.dates = [
      moment()
        .subtract(6, "d")
        .toDate(),
      moment().toDate()
    ];
    this.hasGender = false;
    this.hasBirth_date = false;
    this.dateSD = moment()
      .subtract(6, "d")
      .format("YYYY-MM-DD");
    this.dateED = moment()
      .format("YYYY-MM-DD");

    ws.getClientFields("614cb27a1e85c911f39cd112")
      .then(response => {
        this.fields = response.data.fields.filter(
          el => el.type != "label" && el.is_active
        );

        //this.fields.push({ type: "string", name: "mac", label: "MAC" });
        this.fields = this.fields.map(el => el.name);

        this.fields.forEach(el => {
          if (el === "gender") {
            this.hasGender = true;
          }
          if (el === "birth_date") {
            this.hasBirth_date = true;
          }
        });
      })
      .catch(err => {});

    this.loadGeneralData();
    this.getPessoas(this.dateSD, this.dateED);
  },

  methods: {
    ...mapActions(["logout"]),
    getController_id() {
      if (store.state.client) {
        return 'teresina'
      } else {
        return "";
      }
    },
    openModal() {
      this.dialogList = true;
    },
    closeModal() {
      this.dialogList = false;
    },
    closeAlert() {
      this.dialogAlert = false;
    },
    selectDate() {
      if (
        moment(this.dates[1]).diff(moment(this.dates[0]), "days") > 60 ||
        moment().diff(moment(this.dates[0]), "days") > 365
      ) {
        alert("Por favor limite sua escolha a 60 dias.");
        this.dates[1] = "";
        this.dates[0] = "";
      } else {
        this.dateSD = moment(this.dates[0]).format("YYYY-MM-DD");
        this.dateED = moment(this.dates[1])
          .format("YYYY-MM-DD");

        this.getPessoas(this.dateSD, this.dateED);
        this.loadGeneralData();
      }
    },
    dateConverter(dates) {
      return dateParser(dates[0]) + " - " + dateParser(dates[1]);
    },
    async importUsers(start_date, end_date) {
      this.dialogImport = false;
      var sd = moment(start_date).format();
      var ed = moment(end_date)
        .format();

      this.downloadingUsers = true;

      await downloadUsers(this.getID, sd, ed, this.getFields);

      this.downloadingUsers = false;
    },
    async importConnections(start_date, end_date) {
      this.dialogImport = false;
      var sd = moment(start_date).format();
      var ed = moment(end_date)
        .format();

      await downloadConnections(store.state.client.id, sd, ed);
    },
    getClientName() {
      return store.state.client.name;
    },
    async getPessoas(start_date, end_date) {
      this.isLoading = true;

      this.pessoas = await getPeople(this.getID, start_date, end_date);

      this.isLoading = false;
    },
    formatDate(date_) {
      var date = date_;
      var saida = "";

      try {
        if (isNaN(new Date(date).getTime())) {
          date = date_
            .split("/")
            .reverse()
            .join("/");
        }

        saida = new Date(date).toLocaleDateString("pt-BR");
      } catch (exc) {
        saida = "Invalid Date";
      }

      return saida;
    },
    getClient_id() {
      if (store.state.client) {
        return store.state.client.id;
      } else {
        return "";
      }
    },
    loadGeneralData() {
      if (this.debug_mode == 1)
        console.log("loadIterations: ", this.loadIterations);
      const formatDate = "YYYY/MM/DD";
      var startDate = this.dateSD;
      var endDate = this.dateED;
      var today = moment().format(formatDate);
      var evalToday = false;
      var data_v2 = [];

      //nunca calcular dias maiores q hoje
      if (endDate > today) endDate = today;

      var dates = getDates(startDate, endDate, formatDate);

      var datesSearch = dates.slice(0);

      if (datesSearch.at(-1) == today) {
        evalToday = true;
      }
      //if(this.debug_mode == 1) console.log(datesSearch)

      var p1 = new Promise(resolve => {
        var index = 0;
        if (store.state && store.state.client) {
          if (!evalToday && this.loadIterations > 0) {
            //skip
          } else {
            //nao precisamos ficar atualizando os sumarios de dias anteriores pra sempre
            //if (this.loadIterations >0){

            var summaryStartDate = startDate;
            var summaryEndDate = endDate;

            if (this.debug_mode == 1) console.log(datesSearch);
            if (this.debug_mode == 1)
              console.log("summaryEndDate = ", summaryEndDate);
            if (this.debug_mode == 1)
              console.log("summaryStartDate = ", summaryStartDate);
            if (this.debug_mode == 1) console.log("evalToday = ", evalToday);

            ws.getSummary(
              this.getController_id(),
              summaryStartDate,
              summaryEndDate
            ).then(response => {
              if (this.debug_mode == 1)
                console.log("response summary date: ", response.data.length);
              response.data.sort(function(a, b) {
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                return new Date(a.datetime) - new Date(b.datetime);
              });
              if (this.debug_mode == 1) console.log(response);

              //carrega data_v2 com 1 sumario de cada data. Se houver data repetida no sumario, nao será utilizada
              response.data.forEach(el => {
                if (!data_v2.some(el2 => el2.datetime == el.datetime)) {
                  if (this.debug_mode == 1) console.log(el);
                  data_v2.push(el);
                } else {
                  if (this.debug_mode == 1) console.log("hein?");
                }
              });

              //valida se todas as datas ja possuem sumario
              data_v2.forEach(el => {
                var cursor = moment(el.datetime).format(formatDate);
                if (dates.includes(cursor)) {
                  if (this.debug_mode == 1) console.log(datesSearch);
                  datesSearch.splice(datesSearch.indexOf(cursor), 1);
                }
              });
              if (this.debug_mode == 1) console.log(datesSearch);
              //se todas as datas ja possuirem sumario, resolve a promise
              if (datesSearch.length == 0) resolve(data_v2);

              datesSearch.forEach(el => {
                ws.getConnectionsByClientIdDates(
                  this.getClient_id(),
                  el,
                  moment(el)
                    .format(formatDate)
                )
                  .then(response2 => {
                    var obj = {
                      datetime: el,
                      client_id: this.getClient_id(),
                      age_ranges: [
                        //TODO criar array de acordo com quantos ranges existem e TODO2 deixar dinamico de acordo com cliente
                        [0, 0, 0],
                        [0, 0, 0],
                        [0, 0, 0],
                        [0, 0, 0],
                        [0, 0, 0],
                        [0, 0, 0],
                        [0, 0, 0],
                        [0, 0, 0]
                      ]
                    };

                    var macs = [];

                    var f = 0;
                    var m = 0;
                    var na = 0;
                    response2.data.forEach(conn => {
                      var user = conn.userAuth;

                      if (!!user && typeof user == "object") {
                        if (!macs.includes(user.mac)) {
                          macs.push(user.mac);

                          if (user.hasOwnProperty("birth_date")) {
                            var birth_date = user.birth_date;

                            if (isNaN(new Date(birth_date).getTime())) {
                              birth_date = birth_date
                                .split("/")
                                .reverse()
                                .join("/");
                            }
                            //TODO atualizar idade periodicamente dos sumarios antigos, e compensar os sumarios quando forem calculados depois de um ano

                            var age = moment().diff(birth_date, "years");
                            var found = false;

                            for (
                              var i = 0;
                              i < this.ageRanges.length - 1;
                              i++
                            ) {
                              if (
                                age >= this.ageRanges[i].limits[0] &&
                                age < this.ageRanges[i].limits[1]
                              ) {
                                found = true;

                                if (user.hasOwnProperty("gender")) {
                                  if (
                                    user.gender === "m" ||
                                    user.gender === "M"
                                  ) {
                                    obj.age_ranges[i][0] =
                                      obj.age_ranges[i][0] + 1;
                                    m++;
                                  } else if (
                                    user.gender === "f" ||
                                    user.gender === "F"
                                  ) {
                                    obj.age_ranges[i][1] =
                                      obj.age_ranges[i][1] + 1;
                                    f++;
                                  } else {
                                    obj.age_ranges[i][2] =
                                      obj.age_ranges[i][2] + 1;
                                    na++;
                                  }
                                } else {
                                  obj.age_ranges[i][2] =
                                    obj.age_ranges[i][2] + 1;
                                  na++;
                                }
                                continue; //skip for after finding
                              }
                            }
                            //TODO por o range do ultimo elemento para infinito e tirar este bloco debaixo completamente
                            //spoiler. a maior idade ja eh 120 e tem um age range q eh de nao informado. pra que este bloco debaixo?
                            if (!found) {
                              if (user.gender) {
                                if (
                                  user.gender === "m" ||
                                  user.gender === "M"
                                ) {
                                  obj.age_ranges[this.ageRanges.length - 1][0] =
                                    obj.age_ranges[
                                      this.ageRanges.length - 1
                                    ][0] + 1;
                                  m++;
                                } else if (
                                  user.gender === "f" ||
                                  user.gender === "F"
                                ) {
                                  obj.age_ranges[this.ageRanges.length - 1][1] =
                                    obj.age_ranges[
                                      this.ageRanges.length - 1
                                    ][1] + 1;
                                  f++;
                                } else {
                                  obj.age_ranges[this.ageRanges.length - 1][2] =
                                    obj.age_ranges[
                                      this.ageRanges.length - 1
                                    ][2] + 1;
                                  na++;
                                }
                              } else {
                                obj.age_ranges[this.ageRanges.length - 1][2] =
                                  obj.age_ranges[this.ageRanges.length - 1][2] +
                                  1;
                                na++;
                              }
                            }
                          } else {
                            if (user.hasOwnProperty("gender")) {
                              if (user.gender === "m" || user.gender === "M") {
                                obj.age_ranges[this.ageRanges.length - 1][0] =
                                  obj.age_ranges[this.ageRanges.length - 1][0] +
                                  1;
                                m++;
                              } else if (
                                user.gender === "f" ||
                                user.gender === "F"
                              ) {
                                obj.age_ranges[this.ageRanges.length - 1][1] =
                                  obj.age_ranges[this.ageRanges.length - 1][1] +
                                  1;
                                f++;
                              } else {
                                obj.age_ranges[this.ageRanges.length - 1][2] =
                                  obj.age_ranges[this.ageRanges.length - 1][2] +
                                  1;
                                na++;
                              }
                            } else {
                              try {
                                obj.age_ranges[this.ageRanges.length - 1][2] =
                                  obj.age_ranges[this.ageRanges.length - 1][2] +
                                  1;
                                na++;
                              } catch (err) {}
                            }
                          }
                        }
                      }
                    });

                    if (obj.datetime != today)
                      ws.postSummary(obj).then(_ => {
                        if (this.debug_mode == 1)
                          console.log("Salvo sumario do dia ", obj.datetime);
                      });
                    // if(this.debug_mode == 1) console.log("tentou salvar sumario do dia ", obj.datetime);

                    data_v2.push(obj);

                    index++;

                    if (index == datesSearch.length) {
                      resolve(data_v2);
                    }
                  })
                  .catch(err => {});
              });

              ws.getNewUserByClientIdDates(
                this.getController_id(),
                startDate.replace(/\-/g, "-"),
                endDate.replace(/\-/g, "-")
              )
                .then(response => {
                  this.data_news = response.data;
                })
                .catch(err => {});
            });
            // ws.getSummaryNps(
            //   this.getController_id(),
            //   startDate.replace(/\-/g, "/"),
            //   endDate.replace(/\-/g, "/")
            // ).then(response => {
            //   this.summarys_nps = response.data
            //   ws.getQuestionsNpsByControllerId(this.getController_id()).then(response2 => {
            //     this.questions_nps = response2.data
            //   })
            // }).catch(err => {

            // })
          }
        }
      });

      p1.then(res => {
        if (res) {
          this.data_v2 = res;

          this.data_v2.sort(function(a, b) {
            return a.datetime < b.datetime ? -1 : 1;
          });

          this.isLoadingAuthenticated = false;
        }
      });
    }
  },
  computed: {
    ...mapGetters(["ageRanges", "getID", "getClientID", "getControllerId"]),
    getPersonsList() {
      var saida = this.pessoas;

      if (this.isSearch && this.searchTerm.length > 3) {
        saida = this.pessoas.filter(el => {
          var found = false;
          for (var i = 0; i < this.fields.length && !found; i++) {
            var field = this.fields[i];

            if (
              el[field.name] &&
              new RegExp(this.searchTerm, "gi").test(el[field.name])
            )
              found = true;
          }
          return found;
        });
      }
      return saida;
    },
    openAlert() {
      var output = this.dialogAlert;
      return output;
    },
    getHeaders() {
      return this.fields
        .filter(el => el.type != "label")
        .map(el => {
          return {
            text: el.label,
            value: el.name,
            type: el.type,
            sortable: false
          };
        });
    },
    getFields() {
      return this.fields.map(el => el.name);
    },
    dataByAge() {
      var homens = Array(this.ageRanges.length).fill(0);
      var mulheres = Array(this.ageRanges.length).fill(0);
      var ninfo = Array(this.ageRanges.length).fill(0);

      var output = {
        labels: [],
        datasets: [
          {
            label: "Masculino",

            data: homens
          },
          {
            label: "Feminino",

            data: mulheres
          },
          {
            label: "Não Informado / outros",
            data: ninfo
          }
        ]
      };

      if (this.hasGender & this.hasBirth_date) {
        this.ageRanges.forEach(range => {
          output.labels.push(range.label);
        });
        this.data_v2.forEach(el => {
          el.age_ranges.forEach((age_range, index) => {
            homens[index] += age_range[0];
            mulheres[index] += age_range[1];
            ninfo[index] += age_range[2];
          });
        });
      }
      if (!this.hasGender & this.hasBirth_date) {
        this.ageRanges.forEach(range => {
          output.labels.push(range.label);
        });

        this.data_v2.forEach(el => {
          el.age_ranges.forEach((age_range, index) => {
          
          ninfo[0] += age_range[0] + age_range[1] + age_range[2];
        });
        })
  
        output.datasets.splice(0, 2);
      }

      if (this.hasGender & !this.hasBirth_date) {
        output.labels[0] = "Total";
        
        this.data_v2.forEach(el => {
          el.age_ranges.forEach((age_range, index) => {
            homens[0] += age_range[0];
            mulheres[0] += age_range[1];
            ninfo[0] = age_range[2];
          });
        });
        homens.splice(1, 7);
        mulheres.splice(1, 7);
        ninfo.splice(1, 7);
      }

      if (!this.hasGender & !this.hasBirth_date) {
        output.labels[0] = "Total";
        this.data_v2.forEach(el => {
          el.age_ranges.forEach((age_range, index) => {
            ninfo[0] += age_range[0] + age_range[1] + age_range[2];
          });
        });

        ninfo.splice(1, 7);
        homens.splice(1, 7);
        mulheres.splice(1, 7);
      }

      return output;
    },
    dataByAgeNoGender() {
      var labels = [];
      var data = Array(this.ageRanges.length).fill(0);

      this.ageRanges.forEach(range => {
        labels.push(range.label);
      });

      var output = {
        labels: labels,
        datasets: [
          {
            label: "Acessos",

            data: data
          }
        ]
      };

      this.data_v2.forEach(el => {
        el.age_ranges.forEach((age_range, index) => {
          data[index] += age_range[0];
          data[index] += age_range[1];
          data[index] += age_range[2];
        });
      });

      return output;
    },
    dataByGender() {
      var labels = ["Masculino", "Feminino", "Não Informado / Outros"];
      var data = [];

      var homens = Array(this.ageRanges.length).fill(0);
      var mulheres = Array(this.ageRanges.length).fill(0);
      var ninfo = Array(this.ageRanges.length).fill(0);

      this.data_v2.forEach(el => {
        el.age_ranges.forEach((age_range, index) => {
          homens[index] += age_range[0];
          mulheres[index] += age_range[1];
          ninfo[index] += age_range[2];
        });
      });
      data[0] = homens.reduce(
        (total, currentElement) => total + currentElement
      );
      data[1] = mulheres.reduce(
        (total, currentElement) => total + currentElement
      );
      data[2] = ninfo.reduce((total, currentElement) => total + currentElement);

      var output = {
        labels: labels,
        data: data
      };

      return output;
    }
  }
};
function getDates(start_date, end_date, format = "D/M") {
  var startDate = moment(start_date);
  var endDate = moment(end_date);
  var dayDiff = endDate.diff(startDate, "days") + 1;
  if (!dayDiff) {
    dayDiff = 0;
  }

  var saida = Array(dayDiff).fill(null);
  var cursor = startDate.clone();
  saida.forEach((i, k) => {
    saida[k] = cursor.format(format);

    cursor.add(1, "d");
  });

  return saida;
}
</script>

<style scoped>
.capitalize {
  text-transform: capitalize !important;
}
.Rectangle-1 {
  width: 221px !important;
  height: 48px !important;
  border-radius: 4px;
  background-color: #ff9801;
  color: white;
}

.date {
  font-weight: bold;
  color: #1a73e8;
}

.date:hover {
  color: #4cb0f3;
  cursor: pointer;
}

.mini-button {
  background-color: #ff9801;
  color: white;
  padding: 4px 6px;
  border-radius: 3px;
  margin: 0 4px;
  outline: 0;
}

.mini-button.denied {
  background-color: lightgray;
}

.card {
  padding: 10px;
}

#buttonCancelar {
  position: absolute;
  left: 0;
  bottom: 0;
  margin: 18px;
}

.card-footer {
  display: flex;
  flex-direction: column;
}

.subpage {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#header {
  width: 99%;
}

#graphs {
  display: flex;
  flex-direction: column;
}

#subGraphs {
  display: flex;
  flex-direction: row;
}

.cancelButton {
  font-size: 15px;
  margin-left: 90%;
  margin-top: 5px;
}

#buttonList {
  width: 90px;
  position: relative;
}

.containerButton {
  text-align: right;
  padding-right: 10px;
}

.titleGraph {
  color: #424242;
  font-size: 22px;
  font-family: sans-serif;
}

#cardContainer {
  height: 350px;
}

.titleGraph {
  color: #424242;
  font-size: 22px;
  font-family: sans-serif;
}
#cardContainer {
  height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/Acessos.vue